const locale = {
  region: 'Area',
  city: 'City',
  zone: 'Zone',
  searchCityPlaceholder: 'Search by {city}',
  searchZonePlaceholder: 'Search by {city} or {zone}',
  result: 'Result(s)',
  sale: 'Sale',
  off: '{}% Off',
  stockLimited: 'Limited Stock',
  filterLabel: 'Filter by',
  filterTagAll: 'All',
  noData: 'No Data',
  noDataTips1: 'Sorry, no matching result available.',
  noDataTips2: 'Please ',
  noDataTips3: 'reset',
  noDataTips4: ' and try others.'
};
export default locale;